import React from "react";

const NearshoreOnshore = () => {
  return (
    <section className="min-h-screen flex items-center justify-center p-6 pt-16 bg-gray-100">
      <article className="bg-transparent shadow-lg rounded-2xl p-8 w-full max-w-3xl">
        <header className="text-center mb-6">
          <h2 className="text-3xl font-bold text-blue-600">
            Nearshore / Onshore
          </h2>
        </header>

        <section className="mb-6">
          <p className="text-gray-700">
            <b>Nearshore and Onshore Staffing</b> solutions by <b>Talennect</b>{" "}
            provide businesses with access to highly skilled professionals in
            nearby locations. Whether you’re looking for cost-effective talent
            in a neighboring country or expert professionals within your region,
            our strategic hiring approach ensures seamless workforce
            integration.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Why Choose Nearshore / Onshore Staffing?
          </h3>
          <p className="text-gray-700">
            In today’s dynamic business environment, companies need talent that
            is both skilled and accessible. Our <b>nearshore staffing</b> model
            connects you with professionals in geographically close regions,
            offering cultural alignment, similar time zones, and cost
            efficiencies. <b>Onshore staffing</b>, on the other hand, ensures a
            workforce that understands local market dynamics, regulations, and
            customer expectations.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Our Nearshore / Onshore Staffing Process
          </h3>
          <p className="text-gray-700">
            At <b>Talennect</b>, we simplify the recruitment process by
            leveraging our <b>extensive talent network</b> and{" "}
            <b>advanced AI-driven hiring technology</b>. We begin by
            understanding your business needs, then identify and screen
            candidates who meet your technical and cultural requirements. Our
            goal is to deliver top-tier talent that enhances your workforce
            productivity while maintaining cost-effectiveness.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Industries We Serve
          </h3>
          <p className="text-gray-700">
            Our nearshore and onshore staffing solutions cater to industries
            such as{" "}
            <b>IT, finance, engineering, healthcare, manufacturing, and more</b>
            . Whether you need software developers, project managers, or
            operational specialists, we ensure you have the right professionals
            in the right location.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-blue-600">
            Partner with Talennect for Nearshore & Onshore Talent
          </h3>
          <p className="text-gray-700">
            Gain access to a high-quality talent pool while maintaining cost
            efficiency and operational flexibility. <b>Talennect</b> helps
            businesses scale seamlessly with expert staffing solutions. Contact
            us today to explore how our <b>nearshore and onshore recruitment</b>{" "}
            services can support your business success.
          </p>
        </section>
      </article>
    </section>
  );
};

export default NearshoreOnshore;
